import { useState } from "react";
import { SeguimientoItem } from "../Components/SeguimientoItem";
import { instance } from "../Components/config";
import { useLocation } from "react-router-dom";
import { EmptyResult } from "../Components/EmptyResult";
import { DialogAlert } from "../Components/DialogAlert";
import { AlertDialog } from "../Components/AlertDialog";
import { useAuth } from "../Components/AuthContext";
import { LoaderBox } from "../Components/LoaderBox";
import { BackButton } from "../Components/BackButton";

function Seguimientos() {
  const { state } = useLocation();
  const { id } = state;
  const [isLoading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openAlertDialog, setOpenAlertDialog] = useState(false);
  const [alertDialog, setAlertDialog] = useState({});
  const [dialog, setDialog] = useState({});
  const [objEliminar, setObjEliminar] = useState({});
  const { user } = useAuth();

  if (isLoading) {
    async function getItems() {
      try {
        const { data } = await instance.get(
          `/seguimiento/getByActividad/${id}`
        );
        setItems(
          data.map((item) => {
            return {
              ...item,
              evidencias: item.evidencias
                ? item.evidencias.split(";|||//|||;").map((item) => {
                    const evidencia = item.split(";//|||//;");
                    return {
                      descripcion: evidencia[0],
                      nombre: evidencia[1],
                      tipo: evidencia[2],
                      evidenciaId: evidencia[3],
                    };
                  })
                : null,
              reportado: item.reportado
                ? item.reportado.split(";|||//|||;").map((item) => {
                    const unidad = item.split(";//|||//;");
                    return {
                      categoria: unidad[0],
                      unidad: unidad[1],
                      cantidad: unidad[2],
                      unidadId: unidad[3],
                    };
                  })
                : null,
            };
          })
        );
        setLoading(false);
      } catch (err) {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      }
    }
    getItems();
  }
  const eliminarSeguimiento = (
    seguimiento,
    mes,
    mesId,
    evidencias,
    reportado
  ) => {
    setAlertDialog({
      title: "Alerta",
      text: `¿Seguro que deseas eliminar el seguimiento del mes de ${mes}?`,
    });
    setOpenAlertDialog(true);
    console.log(evidencias);
    setObjEliminar({
      seguimiento: seguimiento,
      mes: mesId,
      evidencias: evidencias,
      reportado: reportado,
    });
  };

  const yesClick = () => {
    handleEliminar();
    setOpenAlertDialog(false);
  };
  const noClick = () => {
    setOpenAlertDialog(false);
  };

  const handleEliminar = () => {
    const obj = {
      userId: user.id,
      actividad: id,
      seguimiento: objEliminar.seguimiento,
      mes: objEliminar.mes,
      evidencias: objEliminar.evidencias,
      reportado: objEliminar.reportado,
    };
    console.log(obj);
    instance
      .delete(`seguimiento/`, {
        data: obj,
      })
      .then((res) => {
        setDialog({
          title: "Aviso",
          text: `Se ha eliminado el seguimiento.`,
          redirect: true,
          page: "/Actividad",
          pageState: { id: id },
        });
        setOpenDialog(true);
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally();
  };
  return (
    <LoaderBox isLoading={isLoading}>
      {items.length > 0 &&
        items.map((item, index) => {
          return (
            <SeguimientoItem
              id={item.id}
              coordenadas={item.coordenadas}
              descripcion={item.descripcion}
              ejecutado={item.ejecutado}
              informacion={item.informacion}
              mes={item.mes}
              reportado={item.reportado || []}
              evidencias={item.evidencias || []}
              key={index}
              eliminarSeguimiento={() =>
                eliminarSeguimiento(
                  item.id,
                  item.mes,
                  item.mesId,
                  item.evidencias,
                  item.reportado
                )
              }
            />
          );
        })}
      {/* Se agrega el isLoading a la cláusula para que no muestre el panel mientras obtiene los datos */}
      {!isLoading && items.length === 0 && (
        <EmptyResult principal="No se han registrado seguimientos para esta actividad" />
      )}
      <br />
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
      <AlertDialog
        open={openAlertDialog}
        accept={yesClick}
        acceptText={"Aceptar"}
        decline={noClick}
        declineText={"Cancelar"}
        title={alertDialog.title}
        text={alertDialog.text}
      />
      <BackButton pageState={{id:id}} page="/Actividad" text="Ver Actividad" />
    </LoaderBox>
  );
}

export { Seguimientos };
